import { render, staticRenderFns } from "./MasterclassHeading.vue?vue&type=template&id=1021684a&scoped=true&"
import script from "./MasterclassHeading.vue?vue&type=script&lang=js&"
export * from "./MasterclassHeading.vue?vue&type=script&lang=js&"
import style0 from "./MasterclassHeading.vue?vue&type=style&index=0&id=1021684a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021684a",
  null
  
)

export default component.exports